import type { VendorMetadataExtractor } from './types'
import { extractEmbeddedGps } from './embedded-gps'

export const garminExtractor: VendorMetadataExtractor = {
  vendorId: 'garmin',
  vendorLabel: 'Garmin',
  supportsDirectoryBrowse: false,

  // Garmin's proprietary `eeGPS` atoms are not parsed (out of scope); only generic embedded NMEA / ISO 6709 is read.
  extractFromFiles: extractEmbeddedGps
}
